const initialState = {
  loginInProgress: false,
  userLanguage: "tr",
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_TOKEN": {
      return { ...state, token: action.payload.token };
    }
    case "SET_USER": {
      const { user } = action.payload;

      return {
        ...state,
        me: user,
        userLanguage: user.userLanguage || state.userLanguage || "tr",
      };
    }
    case "SET_USER_LANGUAGE": {
      return { ...state, userLanguage: action.payload.userLanguage };
    }
    case "SET_LOGIN_PROGRESS": {
      return { ...state, loginInProgress: action.payload.inProgress };
    }
    case "SET_PRESENCE_STATUS": {
      return {
        ...state,
        me: { ...state.me, presenceStatus: action.payload.status },
      };
    }

    default:
      return state;
  }
};

export default user;
